import {decodeURIComponentSafe} from '@wandb/weave/common/util/url';
import {matchPath} from 'react-router';

import {RUN_BASE_PATH} from '../../../routes/workspace/singleRunWorkspacePaths';

export type ParsedRunUrl = {
  entityName: string;
  projectName: string;
  runName: string;
};

/**
 * Checks if input is a full address
 */
export function isAbsoluteUrl(input: string): boolean {
  try {
    new URL(input.trim());
    return true;
  } catch {
    return false;
  }
}

export function parseRunUrl(
  input: string,
  currentOrigin = window.location.origin
): ParsedRunUrl | null {
  try {
    const url = new URL(input.trim());
    const currentUrl = new URL(currentOrigin);
    const isHttp = url.protocol === 'http:' || url.protocol === 'https:';
    const isAllowedHost =
      url.origin === currentUrl.origin ||
      url.hostname === 'wandb.ai' ||
      url.hostname.endsWith('.wandb.ai');
    const match = matchPath<ParsedRunUrl>(url.pathname, {
      path: RUN_BASE_PATH,
      exact: false,
    });

    return isHttp && isAllowedHost && match != null
      ? {
          entityName: decodeURIComponentSafe(match.params.entityName),
          projectName: decodeURIComponentSafe(match.params.projectName),
          runName: decodeURIComponentSafe(match.params.runName),
        }
      : null;
  } catch {
    return null;
  }
}
